import { useTranslation } from "react-i18next";

export const EntrySteps = () => {
  const { t } = useTranslation();
  const steps = t('entrySteps.steps', { returnObjects: true });

  return (
    <section 
      id="entry-steps" 
      className="py-12 md:py-16 bg-white"
      data-testid="entry-steps-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <h2 
          className="text-lg md:text-xl font-semibold text-[#1B4D3E] text-center mb-8"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('entrySteps.headline')}
        </h2>

        <div className="space-y-4">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="flex items-start gap-4"
              data-testid={`entry-step-${index}`}
            >
              <div className="w-7 h-7 bg-[#1B4D3E] rounded-full flex items-center justify-center flex-shrink-0 text-white text-sm font-medium">
                {step.number}
              </div>
              <div>
                <h3 className="font-medium text-stone-800 mb-1">
                  {step.title}
                </h3>
                <p className="text-sm text-stone-600">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
